/**
 * Popup de newsletter: cuida do botão "Copiar cupom" e dá um feedback visual
 * de envio no formulário.
 *
 * O envio do formulário continua sendo feito de forma nativa (POST normal,
 * com reload) porque o endpoint /contact do Shopify exige uma submissão real
 * de página para validar a proteção anti-spam da loja: enviar via fetch/AJAX
 * é rejeitado direto pelo Shopify com "Missing CAPTCHA token", então não é
 * algo que dá pra contornar aqui no tema.
 */
(function () {
  'use strict';

  function copyWithFallback(text, done) {
    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '-1000px';
    document.body.appendChild(textarea);
    textarea.select();
    textarea.setSelectionRange(0, text.length);
    var succeeded = false;
    try { succeeded = document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(textarea);
    if (succeeded) { done(); }
  }

  function copyCode(btn) {
    var code = btn.getAttribute('data-coupon-code') || '';
    if (!code) { return; }
    var settled = false;
    var done = function () {
      if (settled) { return; }
      settled = true;
      var original = btn.textContent;
      btn.textContent = 'Copiado! ✓';
      btn.classList.add('is-copied');
      setTimeout(function () {
        btn.textContent = original;
        btn.classList.remove('is-copied');
      }, 2000);
    };
    var fallback = function () {
      if (settled) { return; }
      settled = true;
      copyWithFallback(code, done);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(fallback);
      // Alguns navegadores/ambientes deixam a promise pendente indefinidamente
      // quando a permissão de clipboard não pode ser resolvida automaticamente.
      setTimeout(fallback, 800);
    } else {
      fallback();
    }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.newsletter-popup__coupon-copy');
    if (btn) { copyCode(btn); }
  });

  // Feedback visual só (não intercepta o envio): evita a impressão de popup
  // travado enquanto o navegador processa o POST nativo.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target.closest('newsletter-popup form');
      if (!form) { return; }
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn && !submitBtn.disabled) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Enviando...';
      }
    },
    true
  );
})();
